module.exports = __webpack_public_path__ + "static/media/HOW TO  LOGIN OR SIGN IN IN EZYMIGRATE SYSTEM.9e651468.png";